import isEqual from 'lodash.isequal';
import { useEffect, useState } from 'react';
import type { DataConfig } from './types';

const getRequestConfig = (config: DataConfig) => {
  const { excludedSplitOptions, showRelativeValues, ...rest } = config;

  return rest;
};

export const useRequestConfig = (config: DataConfig) => {
  const [requestConfig, setRequestConfig] = useState(() => getRequestConfig(config));

  useEffect(
    () => {
      const newRequestConfig = getRequestConfig(config);

      if (!isEqual(requestConfig, newRequestConfig)) {
        setRequestConfig(newRequestConfig);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [config],
  );

  return requestConfig;
};
